import { render } from "./FileViewer.vue?vue&type=template&id=a536cf88&scoped=true"
import script from "./FileViewer.vue?vue&type=script&lang=js"
export * from "./FileViewer.vue?vue&type=script&lang=js"

import "./FileViewer.vue?vue&type=style&index=0&id=a536cf88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a536cf88"]])

export default __exports__